import { createStore$ } from '../createStore$';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { DeviceState$ } from './DeviceState$';
import { useRouter } from '@orderx/lab/ui';
import { utilLog } from '../util/utilLog';
import { Iot$ } from './Iot$';

export namespace Remote$ {
    const { useState, useValue } = createStore$({
        initialState: {
            isActive: false,
        },
        cacheKey: 'Remote$',
    });

    export function useClickDebug() {
        const [, setState] = useState();
        const [count, setCount] = React.useState(0);

        useEffect(() => {
            if (count >= 3) {
                setState((state) => {
                    state.isActive = !state.isActive;
                });
            }

            const timeout = setTimeout(() => {
                setCount(0);
            }, 300);

            return () => clearTimeout(timeout);
        }, [count]);

        return () => {
            setCount((count) => count + 1);
        };
    }

    export function Register() {
        const handleClick = Remote$.useClickDebug();
        const isActive = useValue((state) => state.isActive);

        if (!isActive) {
            return <DivClickHandler onClick={handleClick} />;
        }

        return <DebugHeader />;
    }

    function DebugHeader() {
        const [, setState] = useState();
        const { setUrl } = DeviceState$.usePersistedUrl();
        const router = useRouter();

        return (
            <>
                <DivHeader
                    onClick={() => {
                        setState((state) => {
                            state.isActive = false;
                        });
                    }}>
                    Remote mode active. Click to exit
                </DivHeader>

                <Iot$.Subscribe
                    topic={'app/remote'}
                    callback={React.useCallback((data) => {
                        utilLog('app/remote callback', data);

                        if (data?.type === 'PERSIST_URL') {
                            setUrl(data.url || undefined);

                            if (!data.url) {
                                router.push('/');
                            }
                        }

                        if (data?.exitRemoteMode) {
                            setState((state) => {
                                state.isActive = false;
                            });
                        }
                    }, [])}
                />
            </>
        );
    }
}

const DivClickHandler = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100000;
    width: 8vw;
    height: 5vw;
`;

const DivHeader = styled.div`
    position: fixed;
    top: 0;
    z-index: 100000;
    width: 100%;
    background-color: #ffb500;
    font-size: 1rem;
    color: black;
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    padding: 4px;
`;
